import React from "react";

import { OrganizationContextProvider } from "./OrganizationContext";
import { ViewContextProvider } from "./ViewContext";
import { LoggedUserProvider } from "./LoggedUserContext";
import { ClinicalRegisterContextProvider } from "./ClinicalRegisterContext";
import { PrivacyContextProvider } from "./PrivacyContext";
import { ConsentContextProvider } from "./ConsentContext";
import { PatientHealthCareInformationContextProvider } from "./PatientHealthCareInformationContext";
import { ContractContextProvider } from "./ContractContext";
import { DiscussionCaseContextProvider } from "./DiscussionCaseContext";
import { MedicalReportsAgentContextProvider } from "./MedicalReportsAgentContext";
import { GuidanceAgentContextProvider } from "./GuidanceAgentContext";
import { SecretaryAgentContextProvider } from "./SecretaryAgentContext";
import { FluxPayContractContextProvider } from "./FluxPayContractContext";
import { PostAttendanceContextProvider } from "./PostAttendanceContext";
import { HealthPlanContractContextProvider } from "./HealthPlanContractContext";
import { ProntoAtendimentoContractContextProvider } from "./ProntoAtendimentoContractContext";
import { TeleconsultoriaContractContextProvider } from "./TeleconsultoriaContractContext";
import { TeleconsultoriaProfileProvider } from "src-next/modules/teleconsultoria/profile/TeleconsultoriaProfileContext";
import { TeleconsultoriaPresenceProvider } from "src-next/modules/teleconsultoria/presence/TeleconsultoriaPresenceContext";
import { CRMContractContextProvider } from "./CRMContractContext";
import { QuestionnairesContractContextProvider } from "./QuestionnairesContractContext";
import { SideBarContextProvider } from "./SideBarContext";
import { SignatureControlContextProvider } from "./SignatureControlContext";
import { SignatureContextProvider } from "./SignatureContext";
import { PrescriptionAttendenceContextProvider } from "./PrescriptionAttendenceContext";
import { QuestionnaireContextProvider } from "./QuestionnaireContext";
import { MedicalCareContextProvider } from "./MedicalCareContext";
import { InterventionsContextProvider } from "./InterventionsContext";
import { CustomizationContextProvider } from "./CustomizationContext";

import { AlertInviteDialog } from "../components/modals/AlertInviteDialog";
import { TaskWatchingContextProvider } from "./TaskWatchingContext";
import { FluxSignerContextProvider } from "./FluxSignerContext";
import { SidebarNavigationProvider } from "./SidebarNavigationContext";
import { SncrNumeracoesDrawerProvider } from "src-next/modules/sncr";

interface AppProvidersProps {
  children: React.ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <OrganizationContextProvider>
      <ViewContextProvider>
        <HealthPlanContractContextProvider>
          <ProntoAtendimentoContractContextProvider>
            <TeleconsultoriaContractContextProvider>
            {/* Perfil prestadora/afiliada: resolvido uma vez; menu e telas leem daqui. */}
            <TeleconsultoriaProfileProvider>
            {/* Presença global do teleconsultor (um único peer em qualquer tela). */}
            <TeleconsultoriaPresenceProvider>
            <QuestionnairesContractContextProvider>
              <CRMContractContextProvider>
                <SidebarNavigationProvider>
                  <LoggedUserProvider>
                    <ClinicalRegisterContextProvider>
                      <PrivacyContextProvider>
                        <ConsentContextProvider>
                          <PatientHealthCareInformationContextProvider>
                            <ContractContextProvider>
                              <DiscussionCaseContextProvider>
                                <MedicalReportsAgentContextProvider>
                                  <GuidanceAgentContextProvider>
                                    <SecretaryAgentContextProvider>
                                      <FluxPayContractContextProvider>
                                        <PostAttendanceContextProvider>
                                        <SideBarContextProvider>
                                          <AlertInviteDialog />
                                          <FluxSignerContextProvider>
                                            <SignatureControlContextProvider>
                                              <SignatureContextProvider>
                                                <PrescriptionAttendenceContextProvider>
                                                  <QuestionnaireContextProvider>
                                                    <MedicalCareContextProvider>
                                                      <InterventionsContextProvider>
                                                        <CustomizationContextProvider>
                                                          <TaskWatchingContextProvider>
                                                            <SncrNumeracoesDrawerProvider>
                                                              {children}
                                                            </SncrNumeracoesDrawerProvider>
                                                          </TaskWatchingContextProvider>
                                                        </CustomizationContextProvider>
                                                      </InterventionsContextProvider>
                                                    </MedicalCareContextProvider>
                                                  </QuestionnaireContextProvider>
                                                </PrescriptionAttendenceContextProvider>
                                              </SignatureContextProvider>
                                            </SignatureControlContextProvider>
                                          </FluxSignerContextProvider>
                                        </SideBarContextProvider>
                                        </PostAttendanceContextProvider>
                                      </FluxPayContractContextProvider>
                                    </SecretaryAgentContextProvider>
                                  </GuidanceAgentContextProvider>
                                </MedicalReportsAgentContextProvider>
                              </DiscussionCaseContextProvider>
                            </ContractContextProvider>
                          </PatientHealthCareInformationContextProvider>
                        </ConsentContextProvider>
                      </PrivacyContextProvider>
                    </ClinicalRegisterContextProvider>
                  </LoggedUserProvider>
                </SidebarNavigationProvider>
              </CRMContractContextProvider>
            </QuestionnairesContractContextProvider>
            </TeleconsultoriaPresenceProvider>
            </TeleconsultoriaProfileProvider>
            </TeleconsultoriaContractContextProvider>
          </ProntoAtendimentoContractContextProvider>
        </HealthPlanContractContextProvider>
      </ViewContextProvider>
    </OrganizationContextProvider>
  );
}
